import dataApplicationsContext from "../../../context/dataApplicationsContext"
import { useContext } from 'react';
import UserGoBack from "../../user/UserGoBack";
import RightPartContent from "../RightPartContent";
import ArticleUtile from "../ArticleUtile";
import TagsAnchorContainer from "../TagsAnchorContainer";
import { useSectionRefs } from "../../../hooks/useSectionRefs";

const HelpTopicModificationInscription = () => {
  const { windowWidth } = useContext(dataApplicationsContext);
  const { anchorsParts, topic, isLoading, LoadingComponent } = useSectionRefs();
  if (isLoading) return <LoadingComponent />;

  const isSmallDevise = windowWidth < 900;  

  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Tous les sujets', link: '/topics'},
    { label: 'Vos inscriptions', link: '/topics/inscription/modification'},
    { label: topic.title, link: topic.link},
  ];

  // <a target='_blank' className="link" href="https://wodzone.fr">https://wodzone.fr</a>


  return (
    <div className="user-setting-container help">
      <UserGoBack
        goBackLinks={goBackLinks} isSmallDevise={isSmallDevise} guideInfo={topic.slug} titleClass='mb-0 w-help-title'
      />
      <div className="help-content-container mt-16">
        <div className="help-content-flex mb-80">
          <div className="help-left-part">
            <p className="help-text">
              Si la date limite de modification n'est pas dépassée, vous pourrez modifier les informations saisies lors de votre inscription.
            </p>
            <p className="help-text">
              Toutes vos<a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/account-settings/events`}>informations d'inscription</a>
              sont disponibles depuis votre compte. Il vous suffit de cliquer sur la compétition qui vous intéresse pour les consulter.
            </p>
            <TagsAnchorContainer parts={anchorsParts} legend='Dans cet article'/>
            <div className="article-container mt-40" ref={anchorsParts[0].ref}>
              <p className="help-title-part">{anchorsParts[0].content}</p>
              <p className="help-text">
                Il n’existe pas de règle stricte concernant cette date limite. L’organisateur de la compétition peut la définir selon ses préférences. 
                Si aucune date limite n’a été spécifiée, vous pourrez modifier vos informations jusqu’à la veille de l’événement.
              </p>
            </div>
            <div className="article-container mt-56" ref={anchorsParts[1].ref}>
              <p className="help-title-part">{anchorsParts[1].content}</p>
              <p className="help-text">
                Après votre inscription à une compétition, et pendant la période autorisée de modification, vous pouvez changer :
              </p>
              <ul className="mt-0">
                <li className="pl-8 mb-8"><p className="help-text">Le nom d'équipe.</p></li>
                <li className="pl-8 mb-8"><p className="help-text">Vos informations personnelles (nom, prénom, e-mail, téléphone, date de naissance, genre).</p></li>
                <li className="pl-8 mb-8"><p className="help-text">Vos tailles pour les goodies s'il y en a.</p></li>
                <li className="pl-8 mb-8">
                  <p className="help-text">
                    Vous pouvez également modifier les informations personnelles des autres membres de l'équipe, <strong>uniquement</strong> si ces informations ont été saisies 
                    manuellement et non via la sélection d'un athlète existant.
                  </p>
                </li>
              </ul>
            </div>
            <div className="article-container mt-56" ref={anchorsParts[2].ref}>
              <p className="help-title-part mb-8">{anchorsParts[2].content}</p>
              <p className="help-text mt-24">
                On va appeler capitaine, l'athlète qui a validé l'inscription pour lui et pour son équipe.
              </p>
              <p className="help-text mt-24">
                Le capitaine peut modifier tous les membres de l'équipe, y compris lui-même. Les autres membres de l'équipe ne peuvent changer que leur propre place. <br/>
                Pour ce faire, cliquez sur le bouton <i class="fa-solid fa-people-arrows mr-6 ml-6"></i> situé en haut à droite de la section <strong>Athlète :</strong>
              </p>
              <ul className="mt-0">
                <li className="pl-8 mb-8"><p className="help-text">Saisissez le nom du nouvel athlète si celui possède déjà un compte Wodzone.</p></li>
                <li className="pl-8 mb-8">
                  <p className="help-text">
                    Sinon cliquez sur <strong>Cet athlète n'est pas présent ?</strong> puis saississez toutes les informations personnelles de ce nouvel athlète.
                  </p>
                </li>
                <li className="pl-8 mb-8"><p className="help-text">Cliquer sur enregistrer.</p></li>
                <li className="pl-8 mb-8">
                  <p className="help-text">
                    Tous les athlètes concernés par cette opération recevront un e-mail confirmant la mise à jour.
                  </p>
                </li>
              </ul>
            </div>
            <div className="article-container mt-56" ref={anchorsParts[3].ref}>
              <p className="help-title-part mb-8">{anchorsParts[3].content}</p>
              <p className="help-text mt-24">
                Si la date limite de modification est dépassée, vous pouvez toujours tenter de contacter l'organisateur pour lui exposer votre demande.
              </p>
              <p className="help-text mt-24">
                Voir<a target='_blank' className="link" href={'/topics/inscription/37'}>l'article</a>pour plus d'explication.
              </p>
            </div>
            <ArticleUtile id_topic={topic.id_topic}/>
          </div>
          <RightPartContent />
        </div>
      </div>
    </div>
  )
}

export default HelpTopicModificationInscription